module.exports = __webpack_public_path__ + "static/coral-reef-awareness-i-259e88670e99e78eba2156bd08940c2f.jpg";